class Equipe
{
    constructor()
    {
        this.timeoutMember = 0;
        this.teamIndex = 30;
        this.currentImgOver = null;
        this.currentImgRotation = 0;
        this.isMoving = false;
        this.match = gsap.matchMedia();
        this.employesImages = [];
        this.timeout = null;
        this.isMoving = false;
        this.firstEmploye = null;
        this.currentOver = null;

        this.init();
    }

    init()
	{
        const teamMembers = gsap.utils.toArray(".team-member");
        
        teamMembers.forEach(member => 
        {
            member.addEventListener('mouseenter', (event) => this.onMemberEnter(event));
            member.addEventListener('mouseleave', (event) => this.onMemberLeave(event));
        });

        if(document.querySelector('.liste-equipe') == null) return;

        const listeEquipe = gsap.utils.toArray('.liste-equipe li');
        listeEquipe.forEach(employe => 
        {
            employe.addEventListener('mouseenter', (event) => this.onEmployeOver(event));
            employe.addEventListener('mouseleave', (event) => this.onEmployeLeave(event));
        });
        
        let randomEmploye = Math.floor(Math.random() * listeEquipe.length);
        listeEquipe[randomEmploye].classList.add('active');
        this.onEmployeOver({currentTarget:listeEquipe[randomEmploye]});
        this.firstEmploye = listeEquipe[randomEmploye];
        this.currentOver = listeEquipe[randomEmploye];
	}

    onEmployeOver(e)
    {
        if(this.firstEmploye != null) {
            this.firstEmploye.classList.remove('active');
            gsap.to(this.firstEmploye, {x:0, duration:0.5, ease:'power3.out'});
            this.firstEmploye = null;
        }

        if(e != null) {
            this.currentOver = e.currentTarget;
        }
    
        this.timeout = setTimeout((e) =>
        {
            let currentDiv = document.querySelector('.equipe-img .bg-img-container > div:last-child');
            let image = this.currentOver.getAttribute('data-image');


            gsap.to(this.currentOver, {x:40, duration:0.5, ease:'power3.out'});

            if(currentDiv) {
                let currentImg = currentDiv.querySelector('img');
                if(currentImg) {
                    if(currentImg.src == image) return;
                }
            }

            if(this.isMoving) {
                setTimeout(() => {
                    this.onEmployeOver(e);
                }, 200);
                return;
            }
            
            
            this.isMoving = true;
            let poste = this.currentOver.getAttribute('data-poste');
            let email = this.currentOver.getAttribute('data-email');
            let tel = this.currentOver.getAttribute('data-tel');
            
            if(this.employesImages.filter(img => img.src == image).length == 0) {

                let div = document.createElement('div');
                div.classList.add('hexa-container');

                let img = new Image();
                img.src = image;
                img.onload = () =>
                {
                    gsap.set(div, {xPercent:-103});
                    document.querySelector('.equipe-img .bg-img-container').appendChild(div);
                    div.appendChild(img);
                    var c = document.createElement('canvas');
                    c.classList.add('hexagone');
                    c.classList.add('hexa-2-4');
                    c.width = 300;
                    c.height = 300;
                    div.appendChild(c);
                    this.employesImages.push(img);
                    window.dispatchEvent(new Event('resize'));

                    if(currentDiv) {
                        gsap.to(currentDiv, {xPercent:103, duration:1, ease:'power3.inOut'});
                    }
                    gsap.to(div, {xPercent:0, duration:1, ease:'power3.inOut', onComplete:() => this.isMoving = false});

                    gsap.to(".equipe-info-content", {alpha:0, duration:0.4, ease:"power3.in", onComplete:() => 
                    {
                        let currentHeight = document.querySelector(".equipe-info-container").offsetHeight;
                        document.querySelector(".equipe-info-content .poste").innerHTML = poste;
                        document.querySelector(".equipe-info-content .email").innerHTML = "<a href='mailto:"+email+"'>"+email+"</a>";
                        document.querySelector(".equipe-info-content .telephone").innerHTML = tel;

                        document.querySelector(".equipe-info-container").style.height = "";
                        let newHeight = document.querySelector(".equipe-info-container").offsetHeight;
                        document.querySelector(".equipe-info-container").style.height = currentHeight + "px";
        
                        gsap.to(".equipe-info-container", {height:newHeight, duration:0.6, ease:"power3.inOut", onUpdate:() =>
                        {
                            window.dispatchEvent(new Event('resize'));
                        }});
                        gsap.to(".equipe-info-content", {delay:0.2, alpha:1, duration:0.4, ease:"power3.out"});
                    }});
                    
                }
            } else {

                let img = this.employesImages.filter(img => img.src == image)[0];
                let div = img.parentNode;

                gsap.set(div, {xPercent:-103});
                document.querySelector('.equipe-img .bg-img-container').appendChild(div);

                gsap.to(currentDiv, {xPercent:103, duration:1, ease:'power3.inOut'});
                gsap.to(div, {xPercent:0, duration:1, ease:'power3.inOut', onComplete:() => this.isMoving = false});
                
                gsap.to(".equipe-info-content", {alpha:0, duration:0.4, ease:"power3.in", onComplete:() => 
                {
                    let currentHeight = document.querySelector(".equipe-info-container").offsetHeight;
                    document.querySelector(".equipe-info-content .poste").innerHTML = poste;
                    document.querySelector(".equipe-info-content .email").innerHTML = email;
                    document.querySelector(".equipe-info-content .telephone").innerHTML = tel;

                    document.querySelector(".equipe-info-container").style.height = "";
                    let newHeight = document.querySelector(".equipe-info-container").offsetHeight;
                    document.querySelector(".equipe-info-container").style.height = currentHeight + "px";
    
                    gsap.to(".equipe-info-container", {height:newHeight, duration:0.6, ease:"power3.inOut", onUpdate:() =>
                    {
                        window.dispatchEvent(new Event('resize'));
                    }});
                    
                    gsap.to(".equipe-info-content", {delay:0.2, alpha:1, duration:0.4, ease:"power3.out"});
                }});
            }
        }, 200);

    }

    onEmployeLeave(e)
    {
        clearTimeout(this.timeout);
        //if(e.currentTarget != this.currentOver) {
            gsap.to(e.currentTarget, {x:0, duration:0.5, ease:'power3.out'});
        //}
    }

    onMemberEnter(e)
    {
        let contentParent = e.currentTarget;

        if(this.timeoutMember) {
            clearTimeout(this.timeoutMember);
        }

        this.timeoutMember = setTimeout(() =>
        {
            this.teamIndex++;
            
            contentParent.style.zIndex = this.teamIndex;
            contentParent.querySelector(".team-img-container").style.visibility = "visible";
            
            let rot = Math.floor(Math.random() * (5 - (-5) + 1)) + (-5);
            this.currentImgOver = contentParent.querySelector(".team-img-container");
            this.currentImgRotation = rot;
            this.isMoving = true;

            gsap.set(this.currentImgOver, {x:0, y:0});
            if(contentParent.querySelector(".team-img img")) {
                gsap.fromTo(contentParent.querySelector(".team-img"), {rotation:0, scale:0.9, x:0, y:0, alpha:0}, {duration:0.4, scale:1, y:0, rotation:rot, alpha:1, ease:"sin.out"});
            }
            
            this.moveImgOver(e);
            
            this.match.add("(min-width: 768px)", () => {
                window.addEventListener('mousemove', (event) => this.moveImgOver(event));
            });

        }, 300);
    }

    onMemberLeave(e)
    {
        clearTimeout(this.timeoutMember);
        let contentParent = e.currentTarget;
        
        gsap.to(contentParent.querySelector(".team-img"), {duration:0.2, scale:0.8, rotation:0, alpha:0, ease:"power3.inOut", onComplete:function()
        {
            contentParent.querySelector(".team-img-container").style.visibility = "hidden";
        }});

        this.currentImgOver  = null;
        this.currentImgRotation = 0;
        window.removeEventListener('mousemove', (event) => this.moveImgOver(event));
    }


    moveImgOver(e)
    {
        const {clientX, clientY} = e;

        if(this.currentImgOver != null) {

            let px = clientX/window.innerWidth * this.currentImgOver.offsetWidth/6;
            let py = clientY/window.innerHeight * this.currentImgOver.offsetHeight/6
            
            let percent = (clientX - window.innerWidth/2) / (window.innerWidth/2);

            gsap.to(this.currentImgOver, {x:-this.currentImgOver.offsetWidth/8 + px, y:-this.currentImgOver.offsetHeight/8 + py, duration:0.5, ease:'sin.out', overwrite:true});
            gsap.to(this.currentImgOver.querySelector(".team-img"), {rotation:percent * this.currentImgRotation, duration:0.5, ease:'sin.out'});
        }
    }
}

export default Equipe;